import { render, staticRenderFns } from "./DefaultMessages.vue?vue&type=template&id=1f80d7a3&scoped=true"
import script from "./DefaultMessages.vue?vue&type=script&lang=js"
export * from "./DefaultMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f80d7a3",
  null
  
)

export default component.exports